'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsXhr = require('../../../utils/xhr');

var _utilsXhr2 = _interopRequireDefault(_utilsXhr);

var GenresService = (function () {
    function GenresService($q, $http, localStorageService) {
        _classCallCheck(this, GenresService);

        this.$q = $q;
        this.$http = $http;
        this.localStorageService = localStorageService;

        this.settings = {
            baseUrl: '/api/beatport',
            ttl: 60 * 60 * 24 * 15
        };
    }

    _createClass(GenresService, [{
        key: 'getGenres',
        value: function getGenres() {
            return new _utilsXhr2['default'](this.$q, this.$http, this.localStorageService).setTTL(this.settings.ttl).setBaseUrl(this.settings.baseUrl).get('genres');
        }
    }]);

    return GenresService;
})();

exports['default'] = GenresService;

GenresService.$inject = ['$q', '$http', 'localStorageService'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/beatport/service/genres_service.js
 ** module id = 33
 ** module chunks = 0
 **/